
import { Mixins, Component, Prop } from 'vue-property-decorator'

import DialogTemplate from '@/_components/dialog/template/template.vue'

@Component({
    name: 'RestrictedToMakePublicDialog',
    components: { DialogTemplate },
})
export default class RestrictedToMakePublicDialog extends Mixins() {
    @Prop() props!: any

    testText = ''

    get observation() {
        return this.props.observation
    }

    get testValid() {
        return this.testText == this.observation.projectObservationId
    }

    submitResponse(value: boolean | null) {
        if (value && !this.testValid) return
        this.$emit('close', value)
    }
}
